/**
 * Creates a random Date object (date + time) between the provided start and end dates.
 *
 * @param {Date} start
 * @param {Date} end
 * @returns {Date}
 */
function getRandomDate(start, end) {
  // get the difference between the 2 dates, multiply it by 0-1,
  // and add it to the start date to get a new date
  const diff = end.getTime() - start.getTime();
  const new_diff = diff * Math.random();
  const date = new Date(start.getTime() + new_diff);
  return date;
}

/**
 * Shuffles array in place.
 *
 * @param {Array} a An array containing the items.
 * @returns {Array}
 */
function shuffleArray(a) {
  if (!Array.isArray(a)) {
    return a;
  }

  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/**
 * Logic to get image URL to use.
 *
 * @param {Object} article
 */
function getImageUrl(article) {
  // There are odd cases where frontCropUrl will exist, but there is actually no real
  // crop data in there. For these cases we must use fallback size, else it might take
  // a standing image and allow that to be as big as it is.
  if (article.frontCropUrl && article.frontCropUrl.includes('height') && article.frontCropUrl.includes('width')) {
    return window.imageServer + article.frontCropUrl;
  }

  // Fallback.
  return `${window.imageServer}?imageId=${article.image}&x=0&y=0&cropw=0&croph=0&width=642&height=337`;
}

function log(...args) {
  const debug = process.env.NODE_ENV !== 'production' ? true : false;
  if (debug) {
    console.log(...args);
  }
}

function isSafari() {
  return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
}

export default {
  getImageUrl,
  getRandomDate,
  shuffleArray,
  log,
  isSafari,
};
